import { useEffect, useState } from 'react'
import { getItemPerPage, subscribeItemPerPage } from './helper'

export const useItemPerPage = () => {
    const [itemPerPage, setState] = useState(getItemPerPage)

    useEffect(() => subscribeItemPerPage(setState), [])

    return itemPerPage
}
